import React from "react";
import { useLocation, Link } from "react-router-dom";
import "../styles/Sidebar.css";

const Sidebar = ({ isOpen = true, isMobile = false }) => {
  const location = useLocation();

  const sidebarRoutes = [
    {
      path: "/bookings",
      name: "Bookings",
    },
    {
      path: "/umrah-packages",
      name: "Packages",
    },
    {
      path: "/travel-options",
      name: "Hotels & Flights",
    },
  ];

  const getSidebarItemClass = (path) => {
    return location.pathname === path || location.pathname.startsWith(path) ? "active" : "";
  };

  return (
    <nav className={`sidebar ${isMobile ? (isOpen ? "toggled" : "") : (!isOpen ? "toggled" : "")}`}>
      <div className="sidebar-content">
        <div className="sidebar-user">
          <img
            src="/images/mfo-resor-logo.avif"
            className="img-fluid rounded-circle"
            alt="MFO Resor Logo"
          />
        </div>
        <ul className="sidebar-nav">
          {sidebarRoutes.map((route, index) => (
            <li
              key={index}
              className={`sidebar-item ${getSidebarItemClass(route.path)}`}
            >
              <Link to={route.path} className="sidebar-link">
                <span className="align-middle">{route.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Sidebar;

